/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Aria_LabelInputs */

const en_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media versions`)
};

const fr_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions médias`)
};

const de_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienversionen`)
};

const it_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioni multimediali`)
};

const ru_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`медиаверсии`)
};

const es_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versiones multimedia`)
};

const zh_cn2_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体版本`)
};

const ja_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア版`)
};

const hi_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया संस्करण`)
};

const pt_pt2_media_tab_aria_label = /** @type {(inputs: Media_Tab_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versões para mídia`)
};

/**
* | output |
* | --- |
* | "Media versions" |
*
* @param {Media_Tab_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_aria_label = /** @type {((inputs?: Media_Tab_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_aria_label(inputs)
	if (locale === "de") return de_media_tab_aria_label(inputs)
	if (locale === "it") return it_media_tab_aria_label(inputs)
	if (locale === "ru") return ru_media_tab_aria_label(inputs)
	if (locale === "es") return es_media_tab_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_aria_label(inputs)
	if (locale === "ja") return ja_media_tab_aria_label(inputs)
	if (locale === "hi") return hi_media_tab_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_aria_label(inputs)
	return en_media_tab_aria_label(inputs)
});